import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle as faSolidQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../i18n/LanguageContext';
import './FAQ.css';
import Footer from '../Footer/FooterWrapper';

const FAQ = () => {
  const { t, tRaw } = useLanguage();
  const items = tRaw('faq.items') || [];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="faq-container">
        <h2>
          <FontAwesomeIcon icon={faSolidQuestionCircle} className="faq-icon" /> {t('faq.title')}
        </h2>

        {items.map((item) => (
          <div className="faq-item" key={item.q}>
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}

        <div className="cta-link">
          <Link to="/">
            <button className="cta-button">{t('faq.backHome')}</button>
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FAQ;
